
export const NOVICE = 'novice';
export const INTERMEDIATE = 'intermediate';
export const EXPERT = 'expert';